module.exports = __webpack_public_path__ + "static/media/depressao.9adc1f03.png";